exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.assets-label[data-v-51d87a16] {\n  font-size: 17px;\n}\n.content-tlist[data-v-51d87a16] {\n  border: none;\n}\n.content-filters .cof-box[data-v-51d87a16] {\n  background: none;\n}\n", ""]);

// exports
